<template>
  <div
    v-infinite-scroll="{ handler: onIntersect, options: { distance } }"
    class="tw:h-px"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(defineProps<{
  /** Distance in pixels before sentinel enters viewport to trigger load */
  distance?: number
  /** If true, disables infinite loading */
  disabled?: boolean
}>(), {
  distance: 0,
  disabled: false,
})

const emit = defineEmits<{
  load: []
}>()

function onIntersect() {
  if (!props.disabled) {
    emit('load')
  }
}
</script>
